@if (form) {
    <form [formGroup]="form" fxLayout="column" fxLayoutAlign="center center" class="pr-48 pl-48 pb-32 pt-32 w-100">
        <div class="h3-semi-bold c-primary-gray-900 text-center"> {{ this.dialogTitle | translate }}</div>

        @if(isReadOnly) {
            @if(isPdfReport) {
                @for (feedback of feedbacks; track trackByFeedbackIndex(index, feedback); let
                    index = $index; let first = $first; let last = $last) {
                    <div class="w-100 mt-16" fxLayout="row" fxLayoutAlign="start start">
                        <div class="cell mr-16" style="width: 300px">
                            <fieldset>
                                <legend class="t5 c-primary-gray-600 no-wrap">{{ 'i18n_af_labelSection' | translate }} {{ index + 1 }}</legend>
                                <div class="t4 c-primary-gray-900">
                                    {{ translateSection(feedback.reportSection) }}
                                </div>
                            </fieldset>
                        </div>

                        <div class="cell mr-16" style="width: 200px">
                            <fieldset>
                                <legend class="t5 c-primary-gray-600 no-wrap">{{ 'i18n_af_labelRate' | translate }}</legend>
                                <div class="t4 c-primary-gray-900">
                                    {{ translateRate(feedback.rate) }}
                                </div>
                            </fieldset>
                        </div>

                        <div class="cell mr-16" style="width: 300px">
                            <fieldset>
                                <legend class="t5 c-primary-gray-600 no-wrap">{{ 'i18n_af_labelFeedbackReason' | translate }}</legend>
                                <div class="t4 c-primary-gray-900">
                                    {{ translateReason(feedback.reason) }}
                                </div>
                            </fieldset>
                        </div>
                    </div>
                }
            } @else {
                <div class="cell mt-24 w-100">
                    <fieldset>
                        <legend class="t5 c-primary-gray-600 no-wrap">{{ 'i18n_af_labelRate' | translate }}</legend>
                        <div class="t4 c-primary-gray-900">
                            {{ translateRate(feedbacks[0].rate) }}
                        </div>
                    </fieldset>
                </div>

                <div class="cell w-100">
                    <fieldset>
                        <legend class="t5 c-primary-gray-600 no-wrap">{{ 'i18n_af_labelFeedbackReason' | translate }}</legend>
                        <div class="t4 c-primary-gray-900">
                            {{ translateReason(feedbacks[0].reason) }}
                        </div>
                    </fieldset>
                </div>
            }
        } @else {
            <div class="mt-16 t2 c-primary-gray-900 pre-wrap text-center">
                {{ this.dialogSubtitle | translate }}
            </div>

            @if(isPdfReport) {
                @for (feedbackForm of form.controls?.feedbacks?.controls; track trackByFeedbackFormIndex(index, feedbackForm); let
                    index = $index; let first = $first; let last = $last) {
                    <div class="w-100 mt-16" fxLayout="row" fxLayoutAlign="start start">
                        <div class="cell mr-16" style="width: 300px">
                            <fieldset>
                                <legend class="t5 c-primary-gray-600 no-wrap">{{ 'i18n_af_labelSection' | translate }} {{ index + 1 }}</legend>
                                <div class="t4 c-primary-gray-900">
                                    {{ translateSection(feedbackForm.controls.section.value) }}
                                </div>
                            </fieldset>
                        </div>

                        <div class="mr-16 field-wrapper" style="width: 200px">
                            <af-dictionary-selector dictionaryName="AI_ANALYST_RATE"
                                [control]="feedbackForm.controls.rate"
                                label="i18n_af_labelRate"
                                placeholder="i18n_af_labelFeedbackValue"/>
                        </div>

                        <div class="mr-16 field-wrapper" style="width: 300px">
                            <af-dictionary-selector dictionaryName="AI_ANALYST_REASON"
                                [control]="feedbackForm.controls.reason"
                                label="i18n_af_labelFeedbackReason"
                                placeholder="i18n_af_labelFeedbackValue"/>
                        </div>
                    </div>
                }
            } @else {
                <div class="mt-24 w-100">
                    <af-dictionary-selector dictionaryName="AI_ANALYST_RATE"
                        [control]="form.controls?.feedbacks?.at(0)?.controls?.rate"
                        label="i18n_af_labelRate"
                        placeholder="i18n_af_labelFeedbackValue"/>
                </div>

                <div class="mt-24 w-100">
                    <af-dictionary-selector dictionaryName="AI_ANALYST_REASON"
                        [control]="form.controls?.feedbacks?.at(0)?.controls?.reason"
                        label="i18n_af_labelFeedbackReason"
                        placeholder="i18n_af_labelFeedbackValue"/>
                </div>
            }

            <ui-kit-button
                class="mt-32"
                [disabled]="form.invalid"
                (clickListener)="submitCreateFeedback()"
                [label]="'i18n_af_buttonSaveRate' | translate"/>
            <ui-kit-button
                class="mt-12"
                type="text"
                (clickListener)="dialogRef.close()"
                [label]="'i18n_af_buttonCancel' | translate"/>
        }
    </form>
}
